import _ from 'lodash';
import { getAccountId, getUserId } from './helpers';

export enum ErrorCodeReason {
	MSISDN_IN_USE = 'MSISDN_IN_USE',
	DUPLICATE_MSISDNS = 'DUPLICATE_MSISDNS'
}

export enum FailedAction {
	FAILED_ACTION_CARD_CHANGE = 'FAILED_ACTION_CARD_CHANGE'
}

const errorMessages: any = {
	'^/subscriptions/account/.*\\?status=new$': 'Aktivoimattomien liittymien haku epäonnistui',
	'^/subscriptions/account/.*\\?status=active$': 'Aktiivisten liittymien haku epäonnistui',
	'^/subscriptions/order/': 'Liittymien tilaus epäonnistui',
	'^/subscriptions/activate/': 'Liittymän aktivointi epäonnistui',
	'^/subscriptions/create-and-activate': 'Liittymän aktivointi epäonnistui',
	'^/subscriptions/change-sim/': 'Simmin vaihto epäonnistui',
	'^/subscriptions/able-to-activate/': 'Liittymän tilan haku epäonnistui',
	'^/subscriptions/update/': 'Liittymän tietojen päivitys epäonnistui',
	'^/subscriptions/mnp-info/': 'Liittymän tietojen päivitys epäonnistui',
	'^/subscriptions/A-S.*$': 'Liittymän tietojen haku epäonnistui', // In practice subscriptionNumbers starts with A-S
	'^/order/update/': 'Tilauksen päivitys epäonnistui',
	'^/sims/order/.*$': 'Simmien tilaus epäonnistui',
	'^/sims/empty/account/': 'Liittymän tietojen haku epäonnistui',
	'^/order/': 'Tilauksen tietojen haku epäonnistui',
	'^/accounts/update/.*$': 'Asiakastietojen päivitys epäonnistui',
	'^/account/A.*\\offering-change$': 'Tilin päivitys epäonnistui',
	'^/account/A.*$': 'Tilin tietojen haku epäonnistui', // In practice accountNumbers starts with A-
	'^/detailed-subscription-usage.*$': 'Liittymän kulutustietojen haku epäonnistui',
	'^/detailed-usages.*$': 'Kulutustietojen haku epäonnistui',
	'^/billing-periods/.*$': 'Laskutuskausien haku epäonnistui',
	'^/sales-products/.*$': 'Tuotetietojen haku epäonnistui',
	'^/invoice-attachment-pdf/': 'Laskun haku epäonnistui',
	'^/invoice-attachment-excel/': 'Kuluerittelyn haku epäonnistui',
	'^/invoices/': 'Laskujen haku epäonnistui',
	'^/options/update/': 'Asetuksen päivitys epäonnistui',
	'/set-password': 'Salasanan päivitys epäonnistui',
	'^/change-default-payment-method/': 'Maksukortin päivitys epäonnistui'
};

const getErrorCodeBasedReason = (reasons: any) => {
	if (reasons !== undefined) {
		const msisdnInUse = getReasonObject(reasons, ErrorCodeReason.MSISDN_IN_USE);
		if (msisdnInUse !== undefined) {
			return '. Numero ' + msisdnInUse.data + ' on jo käytössä';
		}
		const duplicateMsisdns = getReasonObject(reasons, ErrorCodeReason.DUPLICATE_MSISDNS);
		if (duplicateMsisdns !== undefined) {
			return '. Sama numero ' + duplicateMsisdns.data + ' oli yritetty liittää useampaan eri liittymään';
		}
	}
	return '';
};

export const determineErrorMessage = (reasons: any, endpointAndQueryParameters: any) => {
	const messageItem = Object.keys(errorMessages).find((regexpStr: string) => new RegExp(regexpStr).test(endpointAndQueryParameters));
	if (messageItem !== undefined) {
		const errorMessage = messageItem ? errorMessages[messageItem] : '';
		return errorMessage + getErrorCodeBasedReason(reasons);
	}
	return undefined;
};

export const createErrorItem = (response: any, endpointAndQueryParameters: any) => {
	const reasons = _.has(response, 'error.data.reasons') ? response.error.data.reasons : undefined;
	const message = determineErrorMessage(reasons, endpointAndQueryParameters);
	return {
		message,
		endpointAndQueryParameters,
		response
	};
};

const getReasonObject = (reasons: any, errorCode: ErrorCodeReason) => {
	return reasons.find((item: any) => item.reason === errorCode);
};

export const findErrorByErrorCodeReason = (errors: any, errorCode: ErrorCodeReason) => {
	if (errors && errors.length > 0) {
		return errors.find((error: any) => _.has(error, 'response.error.data.reasons') && getReasonObject(error.response.error.data.reasons, errorCode) !== undefined);
	}
	return undefined;
};

export const createErrorLogObject = (url: string, failedAction: FailedAction, shortError: string, dataTitle: string, data: any) => {
	return {
		emailAddress: getUserId(),
		accountNumber: getAccountId(),
		sourceDetails: {
			url,
			userAgent: navigator.userAgent
		},
		timeStamp: Date.now(),
		failedAction,
		shortError,
		dataTitle,
		data
	};
};
